import { useEffect, type ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useUiStore } from '@/lib/stores/ui';

interface AppShellProps {
  children: ReactNode;
  pageTitle: string;
  crumb?: string;
}

export function AppShell({ children, pageTitle, crumb }: AppShellProps) {
  const { sidebarOpen, closeSidebar } = useUiStore();

  /* Apply dark theme class to body; remove on unmount */
  useEffect(() => {
    document.body.classList.add('app');
    return () => { document.body.classList.remove('app'); };
  }, []);

  return (
    <>
      {/* Mobile overlay — closes sidebar on tap */}
      <div
        className={`sidebar-overlay${sidebarOpen ? ' active' : ''}`}
        onClick={closeSidebar}
        aria-hidden="true"
      />

      <div className="app-shell">
        <Sidebar />

        <div className="app-main">
          <Topbar pageTitle={pageTitle} {...(crumb !== undefined ? { crumb } : {})} />
          <main className="app-view">
            {children}
          </main>
        </div>
      </div>
    </>
  );
}
